import { Branch } from '../base/branch';
import { Aspect } from './aspect';
import { Prototype } from './prototype';

export class Faction extends Branch {
    static _type: string = 'Faction';

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            const { nodes, branches } = source;

            nodes?.forEach((node: any) => {
                if (node?.i_prototype) {
                    this.nodes.push(new Prototype(node));
                } else {
                    this.nodes.push(new Aspect(node));
                }
            });

            branches?.forEach((branch: any) => {
                this.branches.push(new Faction(branch));
            });
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Faction;
    }
}
